<template>
  <view wx:if="{{pageConfig}}">
    <Index
      wx:if="{{show}}"
      pageConfig="{{pageConfig}}"
      info="{{info}}"
    />
    <error-page wx:else message="{{pageErrorMessage}}" exception="{{exception}}" isKf />
    <block wx:if="{{__mpx_mode__ !== 'web'}}"><Loading wx:if="{{loading}}" /></block>
  </view>
</template>

<script>
import { createPage } from '@mpxjs/core'
import viewsMixin from '../../lib/mixin/views-v3'
import { props } from '../../editor/hxz/model/props'
createPage({
  data: { props },
  mixins: [ viewsMixin('kfpassenger') ],
})
</script>
<script name="json">
const config = {
  "navigationBarTitleText": "",
  "backgroundColor": "#ffffff",
  "usingComponents": {
    "Index": "../../editor/hxz/index",
    "error-page": "../../components/common/error-page.mpx?async=error-page",
  },
}
if (__mpx_mode__ !== 'web') {
  config.usingComponents.Loading = '../../components/common/loading.mpx'
}
module.exports = config
</script>
<style lang="stylus" scoped>
</style>
